import { render, staticRenderFns } from "./SettingsLoader.vue?vue&type=template&id=5018cf88&"
import script from "./SettingsLoader.vue?vue&type=script&lang=js&"
export * from "./SettingsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports